import React, { useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { sub } from "date-fns";

const TablecolSpan = ({
  heading,
  columnValue,
  setErrors,
  formValues,
  errorsindex,
  setFormValues,
  setRowIndex,
  errors,
  disabled,
}) => {
  useEffect(() => {
    let newErrors = {};

    columnValue &&
      columnValue.forEach((category, categoryIndex) => {
        category.subvalue.forEach((sub, subIndex) => {
          sub.key.forEach((keyItem, keyIndex) => {
            const name = `${category.key}.${keyItem}`;
            newErrors[name] = {
              rowIndex: subIndex,
              // rowIndex: categoryIndex * category.subvalue.length * 2 + subIndex * 2 + keyIndex, // Unique row index
              message: "",
            };
          });
        });
      });
    if (setRowIndex) {
      setRowIndex((prevIndex) => ({
        ...prevIndex,
        ...newErrors,
      }));
    }
  }, []);

  const handleChange = (e, index) => {
    const { name, value } = e.target;

    if (!/^\d*$/.test(value)) return; // Allow only numeric values

    setFormValues((prevState) => {
      if (!prevState) return {};
      const keys = name.split(".");
      // const updatedData = structuredClone(JSON.parse(JSON.stringify(prevState)));
      const updatedData = structuredClone(prevState);
      let currentLevel = updatedData;
      for (let i = 0; i < keys.length - 1; i++) {
        if (!currentLevel[keys[i]]) {
          currentLevel[keys[i]] = {};
        }
        currentLevel = currentLevel[keys[i]];
      }
      // Update value
      currentLevel[keys[keys.length - 1]] = value ? Number(value) : "";

      const basePath = keys.slice(0, -1).join("."); // Extract base path (e.g., "membershipInAssociationsOrUnions.0")
      const parentObject = keys
        .slice(0, -1)
        .reduce((obj, key) => obj?.[key], updatedData);

      if (parentObject && keys[0] === "membershipInAssociationsOrUnions") {
        //   // Ensure all values are properly initialized before summing
        //   parentObject.NoOfMaleEmployeesCategory = parentObject.NoOfMaleEmployeesCategory || 0;
        //   parentObject.NoOfFemaleEmployeesCategory = parentObject.NoOfFemaleEmployeesCategory || 0;

        const NoOFMale = parentObject.NoOfMaleEmployeesCategory ?? "";
        const NoOfFemale = parentObject.NoOfFemaleEmployeesCategory ?? "";

        //   // Calculate new totals
        const totalMale = parentObject.totalMaleEmployees;
        const totalFemale = parentObject.totalFemaleEmployees;

        if (
          (keys[keys.length - 1] === "NoOfMaleEmployeesCategory" &&
            NoOFMale > totalMale) ||
          (keys[keys.length - 1] === "NoOfFemaleEmployeesCategory" &&
            NoOfFemale > totalFemale)
        ) {
          return prevState; // Prevent updating state
        }

        parentObject.totalEmployeesCategory = totalMale + totalFemale || 0;
        parentObject.NoofEmployeesCategory = NoOFMale + NoOfFemale || 0;
        parentObject.totalfemaleEmployeesPercentage =
          NoOfFemale !== "" &&
          console.log(NoOfFemale, totalFemale, "data for the");
        parentObject.totalfemaleEmployeesPercentage =
          NoOfFemale !== "" &&
          NoOfFemale !== undefined &&
          totalFemale !== "" &&
          totalFemale !== undefined
            ? (NoOfFemale / totalFemale) * 100 || 0
            : " ";
        parentObject.totalMaleEmployeesPercentage =
          NoOFMale !== "" &&
          NoOFMale !== undefined &&
          totalMale !== "" &&
          totalMale !== undefined
            ? (NoOFMale / totalMale) * 100 || 0
            : " ";
        //         parentObject.totalfemaleEmployeesPercentage = calculatePercentage(NoOfFemale, totalFemale);
        // parentObject.totalMaleEmployeesPercentage = calculatePercentage(NoOFMale, totalMale);
      } else if (parentObject && keys[0] === "trainingDetails") {
        const lastKey = keys[keys.length - 1];
        const editingValue = parentObject?.[lastKey];
        const male =
          lastKey === "totalMale" ? editingValue : parentObject?.totalMale;
        const female =
          lastKey === "totalFemale" ? editingValue : parentObject?.totalFemale;

        const helthMale =
          lastKey === "HealthMaleNumber"
            ? editingValue
            : parentObject?.HealthMaleNumber;
        const helthFemale =
          lastKey === "HealthFemaleNumber"
            ? editingValue
            : parentObject?.HealthFemaleNumber;
        const skillMale =
          lastKey === "SkillMaleNumber"
            ? editingValue
            : parentObject?.SkillMaleNumber;
        const skillFemale =
          lastKey === "SkillFemaleNumber"
            ? editingValue
            : parentObject?.SkillFemaleNumber;

        const isEditingEmpty =
          editingValue === "" ||
          editingValue === null ||
          editingValue === undefined;
        if (lastKey === "totalMale" && isEditingEmpty) {
          parentObject.HealthMaleNumber = "";
          parentObject.SkillMaleNumber = "";
        }

        if (lastKey === "totalFemale" && isEditingEmpty) {
          parentObject.HealthFemaleNumber = "";
          parentObject.SkillFemaleNumber = "";
        }
        const isValidNumber = (v) =>
          v !== "" && v !== null && v !== undefined && !isNaN(Number(v));
        if (
          !isEditingEmpty &&
          isValidNumber(male) &&
          isValidNumber(female) &&
          isValidNumber(helthMale) &&
          isValidNumber(helthFemale) &&
          isValidNumber(skillMale) &&
          isValidNumber(skillFemale)
        ) {
          const totalHealthSkillMale = Number(helthMale) + Number(skillMale);
          const totalHealthSkillFemale =
            Number(helthFemale) + Number(skillFemale);

          if (
            totalHealthSkillMale > Number(male) ||
            totalHealthSkillFemale > Number(female)
          ) {
            return prevState;
          }
        }

        parentObject.Total = male + female || 0;
        parentObject.HealthTotal = helthMale + helthFemale || 0;
        parentObject.HealthMalePercentage =
          helthMale !== "" &&
          helthMale !== undefined &&
          male !== "" &&
          male !== undefined
            ? (helthMale / male) * 100 || 0
            : " ";
        parentObject.HealthFemalePercentage =
          helthFemale !== "" &&
          helthFemale !== undefined &&
          female !== "" &&
          female !== undefined
            ? (helthFemale / female) * 100 || 0
            : " ";
        parentObject.SkillMalePercentage =
          skillMale !== "" &&
          skillMale !== undefined &&
          male !== "" &&
          male !== undefined
            ? (skillMale / male) * 100 || 0
            : " ";
        parentObject.SkillFemalePercentage =
          skillFemale !== "" &&
          skillFemale !== undefined &&
          female !== "" &&
          female !== undefined
            ? (skillFemale / female) * 100 || 0
            : " ";
        parentObject.SkillTotal = skillMale + skillFemale || 0;
      }

      return updatedData;
    });
  };

  return (
    <Box>
      <TableContainer sx={{ borderRadius: "10px", overflow: "hidden" }}>
        <Table
          sx={{
            "& .MuiTableCell-root": {
              border: "1px solid #ccc",
            },
            "& .MuiTableHead-root .MuiTableCell-root": {
              backgroundColor: "#1C486B",
              color: "white",
              fontWeight: "bold",
              textAlign: "center",
            },
            tableLayout: "fixed", // Ensure proper column width allocation
          }}
        >
          <TableHead>
            <TableRow>
              {heading.map((headers, inx) => {
                return headers?.subtitle?.length > 0 ? (
                  <TableCell
                    sx={{
                      textAlign: "center",
                      verticalAlign: "middle",
                      background: "#1C486B",
                      color: "#FFFFFF",
                      padding: "8px 12px",
                      borderRight: "1px solid #DBDBDB",
                    }}
                    colSpan={headers.subtitle.length}
                    key={headers.key}
                  >
                    {headers.title}
                  </TableCell>
                ) : (
                  <TableCell
                    sx={{
                      background: "#1C486B",
                      color: "#FFFFFF",
                      textAlign: "center",
                      verticalAlign: "middle",
                      padding: "8px 12px",
                      borderRight: "1px solid #DBDBDB",
                    }}
                    rowSpan={2}
                  >
                    {headers.title}
                  </TableCell>
                );
              })}
            </TableRow>
            <TableRow>
              {heading.map((headers, inx) => {
                if (headers?.subtitle?.length > 0) {
                  return headers?.subtitle?.map((item, index) => (
                    <TableCell
                      sx={{
                        borderRight: "1px solid #DBDBDB",
                        borderTop: "1px solid #DBDBDB",
                        verticalAlign: "middle",
                        textAlign: "center",
                        padding: "8px 12px",
                        color: "#FFFFFF",
                        background: "#1C486B",
                      }}
                      key={index}
                    >
                      {item.title}
                    </TableCell>
                  ));
                }
                return null;
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {columnValue &&
              columnValue.length > 0 &&
              columnValue.map((category, rowindex) => {
                const [main, sub, field, subfield] = category.key.split(".");
                return (
                  <>
                    <TableRow key={category}>
                      <TableCell rowSpan={4} style={{ fontWeight: "bold" }}>
                        {category.value}
                      </TableCell>
                    </TableRow>
                    {category.subvalue.map((subvalue, colindex) => {
                      const isTotalRow = subvalue.value === "Total";

                      return (
                        <TableRow>
                          <TableCell>{subvalue.value}</TableCell>
                          <TableCell
                            sx={{
                              padding: "0px",
                              height: "32px",
                              lineHeight: "normal", // Prevents text from expanding the cell
                              verticalAlign: "middle",
                              InputProps: {
                                height: "10px",
                              },
                            }}
                          >
                            <TextField
                              //   key={index} // Adding a key for mapping
                              variant="standard"
                              disabled={isTotalRow ? true : disabled}
                              sx={{
                                backgroundColor: isTotalRow
                                  ? "#EFEFEF"
                                  : "white",
                                height: "100%", // Makes TextField fill the cell height
                                "& .MuiInputBase-root": {
                                  height: "100%",
                                  padding: 0,
                                },
                                "& .MuiInputBase-input": {
                                  padding: "0 8px", // Horizontal padding only
                                  height: "100%",
                                  fontSize: "0.875rem",
                                },
                              }}
                              InputProps={{
                                disableUnderline: true,
                              }}
                              name={`${category.key}.${subvalue.key[0]}`}
                              //   type="text"
                              fullWidth
                              size="small"
                              value={
                                formValues?.[main]?.[sub]?.[field]?.[
                                  subvalue.key[0]
                                ]
                              }
                              placeholder="Enter Number"
                              onChange={
                                !isTotalRow ? (e) => handleChange(e) : undefined
                              }
                            />
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "0px",
                              height: "32px",
                              lineHeight: "normal", // Prevents text from expanding the cell
                              verticalAlign: "middle",
                              InputProps: {
                                height: "10px",
                              },
                            }}
                          >
                            <TextField
                              disabled={isTotalRow ? true : disabled}
                              //   key={index} // Adding a key for mapping
                              variant="standard"
                              sx={{
                                backgroundColor: isTotalRow
                                  ? "#EFEFEF"
                                  : "white",
                                height: "100%", // Makes TextField fill the cell height
                                "& .MuiInputBase-root": {
                                  height: "100%",
                                  padding: 0,
                                },
                                "& .MuiInputBase-input": {
                                  padding: "0 8px", // Horizontal padding only
                                  height: "100%",
                                  fontSize: "0.875rem",
                                },
                              }}
                              fullWidth
                              InputProps={{ disableUnderline: true }}
                              name={`${category.key}.${subvalue.key[1]}`}
                              value={
                                formValues?.[main]?.[sub]?.[field]?.[
                                  subvalue.key[1]
                                ]
                              }
                              //  value = {formValues[`${category.key}.${subvalue.key[1]}`]}
                              //   type="text"
                              //   fullWidth
                              //   size="small"
                              //   value={
                              //     differentlyAbled ||turnoverRate
                              //       ? formValues?.[mainKey]?.[subKey.toLowerCase()]?.[fieldKey?.toLowerCase()]?.[differentlyAbledKey?.toLowerCase()] || ""
                              //       : formValues?.[mainKey]?.[subKey.toLowerCase()]?.[fieldKey?.toLowerCase()]|| ""
                              //   }
                              placeholder="Enter Number"
                              onChange={
                                !isTotalRow ? (e) => handleChange(e) : undefined
                              }
                            />
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "0px",
                              height: "32px",
                              lineHeight: "normal", // Prevents text from expanding the cell
                              verticalAlign: "middle",
                              InputProps: {
                                height: "10px",
                              },
                            }}
                          >
                            <TextField
                              disabled={disabled || true}
                              //   key={index} // Adding a key for mapping
                              variant="standard"
                              sx={{
                                backgroundColor: "#EFEFEF",
                                height: "100%", // Makes TextField fill the cell height
                                "& .MuiInputBase-root": {
                                  height: "100%",
                                  padding: 0,
                                },
                                "& .MuiInputBase-input": {
                                  padding: "0 8px", // Horizontal padding only
                                  height: "100%",
                                  fontSize: "0.875rem",
                                },
                              }}
                              InputProps={{ disableUnderline: true }}
                              //   name={"name"}
                              //   type="text"
                              //   fullWidth
                              //   size="small"
                              //   value={
                              //     differentlyAbled ||turnoverRate
                              //       ? formValues?.[mainKey]?.[subKey.toLowerCase()]?.[fieldKey?.toLowerCase()]?.[differentlyAbledKey?.toLowerCase()] || ""
                              //       : formValues?.[mainKey]?.[subKey.toLowerCase()]?.[fieldKey?.toLowerCase()]|| ""
                              //   }
                              name={`${category.key}.${category?.PercentageKeys?.[colindex]}`}
                              value={
                                formValues?.[main]?.[sub]?.[field]?.[
                                  category?.PercentageKeys?.[colindex]
                                ] ||
                                formValues?.[main]?.[sub]?.[field]?.[
                                  category?.PercentageKeys?.[colindex]?.[0]
                                ]
                              }
                              //  value = {formValues[`${category.key}.${category?.PercentageKeys?.[colindex]}`]}
                              placeholder="%"
                              //   onChange={!isTotalRow ? (e) => handleChange(e, index) : undefined}
                            />
                          </TableCell>

                          {category?.rows === "multiple" && (
                            <TableCell
                              sx={{
                                padding: "0px",
                                height: "32px",
                                lineHeight: "normal", // Prevents text from expanding the cell
                                verticalAlign: "middle",
                                InputProps: {
                                  height: "10px",
                                },
                              }}
                            >
                              <TextField
                                disabled={isTotalRow ? true : disabled}
                                //   key={index} // Adding a key for mapping
                                variant="standard"
                                name={`${category.key}.${subvalue.key[2]}`}
                                value={
                                  formValues?.[main]?.[sub]?.[field]?.[
                                    subvalue.key[2]
                                  ]
                                }
                                sx={{
                                  backgroundColor: isTotalRow
                                    ? "#EFEFEF"
                                    : "white",
                                  height: "100%", // Makes TextField fill the cell height
                                  "& .MuiInputBase-root": {
                                    height: "100%",
                                    padding: 0,
                                  },
                                  "& .MuiInputBase-input": {
                                    padding: "0 8px", // Horizontal padding only
                                    height: "100%",
                                    fontSize: "0.875rem",
                                  },
                                }}
                                InputProps={{ disableUnderline: true }}
                                onChange={
                                  !isTotalRow
                                    ? (e) => handleChange(e)
                                    : undefined
                                }
                                //   name={"name"}
                                //   type="text"
                                fullWidth
                                //   size="small"
                                //   value={
                                //     differentlyAbled ||turnoverRate
                                //       ? formValues?.[mainKey]?.[subKey.toLowerCase()]?.[fieldKey?.toLowerCase()]?.[differentlyAbledKey?.toLowerCase()] || ""
                                //       : formValues?.[mainKey]?.[subKey.toLowerCase()]?.[fieldKey?.toLowerCase()]|| ""
                                //   }
                                placeholder="Enter Number"
                                //   onChange={!isTotalRow ? (e) => handleChange(e, index) : undefined}
                              />
                            </TableCell>
                          )}

                          {category?.rows === "multiple" && (
                            <TableCell
                              sx={{
                                padding: "0px",
                                height: "32px",
                                lineHeight: "normal", // Prevents text from expanding the cell
                                verticalAlign: "middle",
                                InputProps: {
                                  height: "10px",
                                },
                              }}
                            >
                              <TextField
                                disabled={disabled || true}
                                //   key={index} // Adding a key for mapping
                                variant="standard"
                                sx={{
                                  backgroundColor: "#EFEFEF",
                                  height: "100%", // Makes TextField fill the cell height
                                  "& .MuiInputBase-root": {
                                    height: "100%",
                                    padding: 0,
                                  },
                                  "& .MuiInputBase-input": {
                                    padding: "0 8px", // Horizontal padding only
                                    height: "100%",
                                    fontSize: "0.875rem",
                                  },
                                }}
                                InputProps={{ disableUnderline: true }}
                                name={`${category.key}.${category?.PercentageKeys?.[colindex]}`}
                                value={
                                  formValues?.[main]?.[sub]?.[field]?.[
                                    category?.PercentageKeys?.[colindex]
                                  ] ||
                                  formValues?.[main]?.[sub]?.[field]?.[
                                    category?.PercentageKeys?.[colindex]?.[1]
                                  ]
                                }
                                //   name={"name"}
                                //   type="text"
                                //   fullWidth
                                //   size="small"
                                //   value={
                                //     differentlyAbled ||turnoverRate
                                //       ? formValues?.[mainKey]?.[subKey.toLowerCase()]?.[fieldKey?.toLowerCase()]?.[differentlyAbledKey?.toLowerCase()] || ""
                                //       : formValues?.[mainKey]?.[subKey.toLowerCase()]?.[fieldKey?.toLowerCase()]|| ""
                                //   }
                                placeholder="%"
                                // onChange={
                                //   !isTotalRow ? (e) => handleChange(e) : undefined
                                // }
                                //   onChange={!isTotalRow ? (e) => handleChange(e, index) : undefined}
                              />
                            </TableCell>
                          )}
                        </TableRow>
                      );
                    })}
                  </>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>

      {Object.entries(errors?.employees ?? {}).map(([rowIndex, items]) => (
        <Typography
          variant="body2"
          color="error"
          key={`error-employees-${rowIndex}`}
          style={{
            lineHeight: "1.2",
            margin: "2px 0",
            color: "#d34040",
            fontSize: "10px",
            fontStyle: "italic",
            marginTop: "0px",
          }}
        >
          Row employees{rowIndex}: Missing fields -{" "}
          {items.map((item) => item.fieldName).join(", ")}
        </Typography>
      ))}

      {Object.entries(errors?.workers ?? {}).map(([rowIndex, items]) => (
        <Typography
          variant="body2"
          color="error"
          key={`error-workers-${rowIndex}`}
          style={{
            lineHeight: "1.2",
            margin: "2px 0",
            color: "#d34040",
            fontSize: "10px",
            fontStyle: "italic",
            marginTop: "0px",
          }}
        >
          Row workers{rowIndex}: Missing fields -{" "}
          {items.map((item) => item.fieldName).join(", ")}
        </Typography>
      ))}
    </Box>
  );
};

export default TablecolSpan;
